import React from 'react';
import { ShortUnderlineInput } from 'swag-client-common/components/inputs/pink-underline-input';
import { ColorLabel } from 'swag-client-common/components/ui/color-label';
import classnames from 'classnames';
import RenderStringWithContactUs from 'swag-client-common/components/ui/render-string-with-contact-us';
import { HiddenLabel } from 'swag-client-common/components/hidden-label';
import classes from './quantity-for-color.scss';
export function QuantityForColor(props) {
  const {
    quantity,
    colorName,
    colorValue,
    className = '',
    showColor = true,
    inputClassName = '',
    inputWrapperClassName = '',
    errorClassName = '',
    viewMode = false,
    onChange,
    isDisabled,
    errorMessage
  } = props;
  const onInputChange = e => onChange === null || onChange === void 0 ? void 0 : onChange(parseInt(e.target.value || 0, 10) || 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.container, className),
    "data-color-block": colorName
  }, showColor && /*#__PURE__*/React.createElement(ColorLabel, {
    colorValue: colorValue,
    colorName: colorName,
    className: classnames(classes.buttonContainerLeft, classes.colorButtonWrapper)
  }), /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.input, inputWrapperClassName)
  }, /*#__PURE__*/React.createElement(HiddenLabel, {
    htmlFor: `quantityForColor-${colorName}`,
    label: "Quantity for color:"
  }), /*#__PURE__*/React.createElement(ShortUnderlineInput, {
    id: `quantityForColor-${colorName}`,
    dataInput: "Quantity",
    value: quantity,
    className: inputClassName,
    onChange: onInputChange,
    disabled: isDisabled,
    viewMode: viewMode
  }))), !!errorMessage && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.error, errorClassName),
    "data-error": "errorMessage"
  }, /*#__PURE__*/React.createElement(RenderStringWithContactUs, {
    string: errorMessage
  })));
}